export default __webpack_public_path__ + "static/media/hope-island-game.b1030f0c.jpg";